import React from 'react';
import factory from 'components/Icons/factory';

export const Facebook = factory(
  'Facebook',
  <path d="M50.2 128L50.2 72.8 32.1 72.8 32.1 51.3 50.2 51.3 50.2 35.4C50.2 17 61.2 7 77.1 7 84.8 7 91.4 7.6 93.3 7.9L93.3 27.1 82.2 27.1C73.5 27.1 71.8 31.3 71.8 37.6L71.8 51.3 92.6 51.3 89.9 72.8 71.8 72.8 71.8 128 50.2 128 50.2 128 50.2 128Z" />
);

export default Facebook;
